import draugasAugustPdf from "../../../content/attachments/articles/2013-08-24-DRAUGAS.pdf?url";
import draugasSeptemberPdf from "../../../content/attachments/articles/2013-09-28-DRAUGAS.pdf?url";
import pdf1 from "../../../content/attachments/articles/2026-09-24-14h31m40s-P2IbKkO--3-9-straipsnis 2001__att-01.pdf?url";
import pdf2 from "../../../content/attachments/articles/2026-09-24-14h31m40s-P2IbKkO--3-9-straipsnis 2001__att-02.pdf?url";
import draugasAugustPage4 from "./assets/draugas-2013-08-24-page-4.jpg";
import draugasSeptemberPage10 from "./assets/draugas-2013-09-28-page-10.jpg";
import draugasSeptemberPage11 from "./assets/draugas-2013-09-28-page-11.jpg";
import page38 from "./assets/publication-2001-page-38.jpg";
import page39 from "./assets/publication-2001-page-39.jpg";
import type { Localized } from "./catalog";

type ArticleSource = {
  id: string;
  mediaUrl?: string;
  label?: string | Localized;
  pageUrl?: string;
  page?: number;
};

// Original page images and complete supplied issue PDFs are local.
// Draugas bibliography and image provenance: docs/DRAUGAS_SOURCE_CORRECTION_20261014.md.
export const articleSources: ArticleSource[] = [
  { id: "article-2001-1", mediaUrl: pdf1, pageUrl: page38, page: 38 },
  { id: "article-2001-2", mediaUrl: pdf2, pageUrl: page39, page: 39 },
  {
    id: "draugas-2013-08-24",
    label: {
      lt: "Draugas · 2013-08-24 · visas numeris (16 p., PDF)",
      en: "Draugas · 2013-08-24 · complete issue (16 pages, PDF)",
    },
    mediaUrl: draugasAugustPdf,
    pageUrl: draugasAugustPage4,
    page: 4,
  },
  {
    id: "draugas-2013-09-28",
    label: {
      lt: "Draugas · 2013-09-28 · visas numeris (16 p., PDF)",
      en: "Draugas · 2013-09-28 · complete issue (16 pages, PDF)",
    },
    mediaUrl: draugasSeptemberPdf,
    pageUrl: draugasSeptemberPage10,
    page: 10,
  },
  {
    id: "draugas-2013-09-28-page-11",
    pageUrl: draugasSeptemberPage11,
    page: 11,
  },
];
